import { makeStyles } from 'tss-react/mui';
import { theme } from '../theme';

/**
 * Custom hook that defines the styles for the layout component.
 */
const useLayoutStyles = makeStyles()(() => ({
  main: {
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    height: 'calc(100vh - 60px)',
    minWidth: '590px',
  },
  rightMain: {
    overflow: 'auto',
    width: '100%',
  },
  rightMainOverlay: {
    position: 'absolute',
    height: '100vh',
    width: '100%',
    overflow: 'auto',
    background: 'black',
    opacity: '0.5',
    zIndex: 3,
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  questionPageButtons: {
    display: 'flex',
    maxWidth: '50%',
  },
  orderButtons: {
    display: 'flex',
    flex: '1',
  },
  rightPadding: {
    padding: '2% 0 2% 2%',
  },
  boldTitle: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.h3,
    fontWeight: theme.fontWeight.bold,
  },
  boldCount: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.h5,
    fontWeight: theme.fontWeight.bold,
  },
  btnIndicatorContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  formPostBtn: {
    marginLeft: 0,
    marginRight: 0,
  },
  container: {
    padding: theme.padding.m,
  },
  pageContainer: {
    margin: theme.margin.l,
  },
}));

export default useLayoutStyles;
